// CNC 파트너 — 정산 (2026-10-23, UI 구조 단계)
// 탭 3개: 매출 명세서(제조사 → 기공소, 출고 기준 자동) / 덴클 청구(덴클 → 제조사, 조회만) / 영업업체 리포트(추천코드별 물량)
// 결제 화면 없음 — 세금계산서는 덴클이 발행, 여기서는 조회만.
import React, { useState } from 'react';
import { Wallet, FileDown, Plus, Copy } from 'lucide-react';
import PageHeader from '../common/PageHeader';
import PartnerStatement from './PartnerStatement';
import { SAMPLE_LABS, SAMPLE_DENCL_BILLS, SAMPLE_SALES } from './partnerSample';
import { useIsMobile, won, SampleNotice, ui } from './partnerUi';

const TABS = [
    { key: 'sales', label: '매출 명세서' },
    { key: 'receivable', label: '미수금' },
    { key: 'dencl', label: '덴클 청구' },
    { key: 'referral', label: '영업업체' },
];

// 덴클 요금 단계(문헌 조사 10-23 권고: 묶음 단계 + 초과분 건당 + 초기 무료 할당, 이름은 「지그 설계 자동화 비용」). 금액은 대표 결정 전 = 미정
const TIERS = [
    { key: 't1', cap: 300, label: '스타터' },
    { key: 't2', cap: 1500, label: '스탠다드' },
    { key: 't3', cap: 5000, label: '프로' },
];
const UNIT_SALE = 55000;   // 비율 수수료 계산용 건당 매출(샘플)

function ReceivableTab({ mobile }) {
    // 미수금 — 양측 확정된 명세서 기준. 이의 중인 명세서는 「보류」. 입금 기록은 제조사가 직접(플랫폼 안 편익 = 우회 억제, 문헌 조사 권고)
    const [rows, setRows] = useState([
        { id: 'lab1', name: '가온치과기공소', billed: 159500, paid: 159500, days: 0, state: 'confirmed' },
        { id: 'lab2', name: '서울덴탈랩', billed: 204600, paid: 0, days: 0, state: 'disputed' },
        { id: 'lab3', name: '한빛기공소', billed: 162800, paid: 100000, days: 12, state: 'confirmed' },
        { id: 'lab4', name: '미소치과기공', billed: 121000, paid: 0, days: 23, state: 'issued' },
        { id: 'lab5', name: '스마일랩', billed: 60500, paid: 60500, days: 0, state: 'confirmed' },
    ]);
    const record = (id) => {
        const v = window.prompt('입금액을 입력하세요 (원)');
        const n = parseInt(String(v || '').replace(/[^0-9]/g, ''), 10);
        if (!n) return;
        setRows((p) => p.map((r) => (r.id === id ? { ...r, paid: Math.min(r.billed, r.paid + n) } : r)));
    };
    const due = rows.filter((r) => r.state === 'confirmed').reduce((s, r) => s + (r.billed - r.paid), 0);
    const held = rows.filter((r) => r.state !== 'confirmed').reduce((s, r) => s + (r.billed - r.paid), 0);
    return (
        <div style={styles.col}>
            <p style={ui.cardSub}>{'지난달 명세서 기준 입금 현황입니다. 양측 확정된 명세서만 미수금으로 잡고, 이의 중이거나 기공소 확인 전인 명세서는 따로 표시합니다.'}</p>
            <div style={styles.addRow}>
                <span style={styles.feeSum}>{'미수금 '}<b style={{ color: '#b91c1c' }}>{won(due)}</b></span>
                <span style={ui.muted}>{'·'}</span>
                <span style={styles.feeSum}>{'확인 전·이의 중 '}<b>{won(held)}</b></span>
            </div>
            <div style={ui.tableWrap}>
                <table style={ui.table}>
                    <thead>
                        <tr>
                            <th style={ui.th}>{'기공소'}</th>
                            <th style={{ ...ui.th, textAlign: 'right' }}>{'청구'}</th>
                            {!mobile && <th style={{ ...ui.th, textAlign: 'right' }}>{'입금'}</th>}
                            <th style={{ ...ui.th, textAlign: 'right' }}>{'잔액'}</th>
                            <th style={ui.th}>{'상태'}</th>
                            <th style={ui.th} />
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((r) => {
                            const left = r.billed - r.paid;
                            const st = r.state === 'disputed' ? { t: '이의 중 · 보류', fg: '#b91c1c', bg: '#fee2e2' }
                                : r.state === 'issued' ? { t: '기공소 확인 전', fg: '#1d4ed8', bg: '#dbeafe' }
                                    : left === 0 ? { t: '완납', fg: '#047857', bg: '#d1fae5' }
                                        : { t: `미수 ${r.days}일`, fg: r.days > 30 ? '#b91c1c' : '#b45309', bg: r.days > 30 ? '#fee2e2' : '#fef3c7' };
                            return (
                                <tr key={r.id}>
                                    <td style={{ ...ui.td, fontWeight: 600 }}>{r.name}</td>
                                    <td style={ui.tdNum}>{won(r.billed)}</td>
                                    {!mobile && <td style={{ ...ui.tdNum, color: '#64748b' }}>{won(r.paid)}</td>}
                                    <td style={{ ...ui.tdNum, fontWeight: 700, color: left ? '#b91c1c' : '#047857' }}>{won(left)}</td>
                                    <td style={ui.td}><span style={{ ...ui.badge, color: st.fg, backgroundColor: st.bg }}>{st.t}</span></td>
                                    <td style={{ ...ui.td, textAlign: 'right' }}>
                                        {left > 0 && r.state === 'confirmed' && <button type="button" style={styles.smallBtn} onClick={() => record(r.id)}>{'입금 기록'}</button>}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

const notReady = (what) => alert(`미리보기: ${what}은(는) 서버 연결 후 동작합니다.`);

function DenclTab() {
    const used = SAMPLE_DENCL_BILLS[0].jigCount;
    const current = TIERS.find((t) => used <= t.cap) || TIERS[TIERS.length - 1];
    return (
        <div style={styles.col}>
            <p style={ui.cardSub}>{'외주로 받은 케이스의 「지그 설계 자동화 비용」입니다. 기공소 안에서 쓴 지그는 기공소가 따로 냅니다. 세금계산서는 덴클이 발행하며, 여기서는 조회만 합니다.'}</p>
            <div style={styles.tierRow}>
                {TIERS.map((t) => (
                    <div key={t.key} style={{ ...styles.tierCard, ...(t.key === current.key ? styles.tierOn : {}) }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <b style={{ fontSize: 14, color: '#0f172a' }}>{t.label}</b>
                            {t.key === current.key && <span style={{ ...ui.badge, color: '#4338ca', backgroundColor: '#e0e7ff' }}>{'이번 달'}</span>}
                        </div>
                        <div style={{ fontSize: 13, color: '#334155' }}>{`월 ${t.cap.toLocaleString()}건까지`}</div>
                        <div style={ui.muted}>{'월 요금 미정 · 초과분 건당 미정'}</div>
                    </div>
                ))}
            </div>
            <p style={ui.muted}>{`이번 달 ${used.toLocaleString()}건 사용 · 가입 첫 달 100건 무료(예시) · 다 못 쓴 건수 일부 다음 달 이월(예시)`}</p>
            <div style={ui.tableWrap}>
                <table style={ui.table}>
                    <thead>
                        <tr>
                            <th style={ui.th}>{'월'}</th>
                            <th style={{ ...ui.th, textAlign: 'right' }}>{'지그 사용'}</th>
                            <th style={ui.th}>{'요금'}</th>
                            <th style={{ ...ui.th, textAlign: 'right' }}>{'청구액'}</th>
                            <th style={ui.th}>{'상태'}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {SAMPLE_DENCL_BILLS.map((b) => (
                            <tr key={b.month}>
                                <td style={ui.td}>{b.month}</td>
                                <td style={ui.tdNum}>{`${b.jigCount.toLocaleString()}개`}</td>
                                <td style={ui.td}>{b.plan}</td>
                                <td style={ui.tdNum}>{won(b.amount)}</td>
                                <td style={ui.td}>{b.status}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <p style={ui.muted}>{'요금·묶음 구성은 미정입니다 — 표시된 값은 화면 배치를 위한 샘플입니다.'}</p>
        </div>
    );
}

function ReferralTab({ mobile }) {
    // 영업업체 = 제조사가 직접 등록·관리하는 영업 파트너(덴클 계정 없음, 대표 10-23). 수수료는 제조사가 영업업체에 직접 지급.
    // 물량 = 그 영업업체 추천코드로 가입한 기공소의 우리 회사 출고 건수. 건당 수수료는 영업업체마다 제조사가 정한다.
    // 수수료 방식(문헌 조사 권고 — 제조사가 고름): fixed 건당 정액(원) / rate 매출 비율(%) / tier 구간(50건까지 낮은 단가, 초과분 높은 단가)
    const [sales, setSales] = useState(() => SAMPLE_SALES.map((x, i) => ({ ...x, method: i === 0 ? 'fixed' : 'rate', fee: i === 0 ? 3000 : 5 })));
    const [newName, setNewName] = useState('');
    const statOf = (sid) => {
        const labs = SAMPLE_LABS.filter((l) => l.via.type === 'sales' && l.via.salesId === sid);
        return { labs: labs.length, month: labs.reduce((s, l) => s + l.monthCount, 0), last: labs.reduce((s, l) => s + l.lastMonthCount, 0) };
    };
    const direct = SAMPLE_LABS.filter((l) => l.via.type === 'direct');
    const add = () => {
        const name = newName.trim();
        if (!name) return;
        const code = `S-${Math.random().toString(36).slice(2, 8).toUpperCase()}`;   // 미리보기용 — 실제 발급은 서버
        setSales((p) => [...p, { id: `s${Date.now()}`, code, name, method: 'fixed', fee: 0, since: new Date() }]);
        setNewName('');
    };
    // 샘플 코드 — 실제 발급(서버·중복 검사) 전에는 링크를 내주지 않는다(가입 데이터에 가짜 값 저장 방지, 시뮬레이션 10-23 [상]3)
    const copyLink = () => alert('미리보기: 추천코드와 가입 링크는 서버 연결 후 실제로 발급됩니다. 지금 코드는 화면 확인용입니다.');
    const commissionOf = (r, n) => {
        if (r.method === 'rate') return Math.round(n * UNIT_SALE * (r.fee || 0) / 100);
        if (r.method === 'tier') return Math.min(n, 50) * 2000 + Math.max(0, n - 50) * 3000;
        return n * (r.fee || 0);
    };
    const feeTotal = sales.reduce((s, r) => s + commissionOf(r, statOf(r.id).month), 0);

    return (
        <div style={styles.col}>
            <div style={ui.toolBar}>
                <p style={{ ...ui.cardSub, flex: 1 }}>{'우리 회사 영업업체를 등록하고 추천코드를 나눠 주세요. 그 코드로 가입한 기공소의 출고 건수로 수수료를 계산합니다. 수수료 지급은 직접 합니다.'}</p>
                <button type="button" style={ui.ghostBtn} onClick={() => notReady('수수료 내역 내보내기')}><FileDown size={14} />{'내보내기'}</button>
            </div>

            <div style={styles.addRow}>
                <input style={{ ...ui.searchInput, maxWidth: 260 }} placeholder="영업업체 이름" value={newName} onChange={(e) => setNewName(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') add(); }} />
                <button type="button" style={ui.primaryBtn} onClick={add}><Plus size={14} />{'영업업체 등록'}</button>
                <span style={{ flex: 1 }} />
                <span style={styles.feeSum}>{'이번 달 지급할 수수료 '}<b>{won(feeTotal)}</b></span>
            </div>

            <div style={ui.tableWrap}>
                <table style={ui.table}>
                    <thead>
                        <tr>
                            <th style={ui.th}>{'영업업체'}</th>
                            <th style={ui.th}>{'추천코드'}</th>
                            <th style={{ ...ui.th, textAlign: 'right' }}>{'소개 기공소'}</th>
                            <th style={{ ...ui.th, textAlign: 'right' }}>{'이번 달'}</th>
                            {!mobile && <th style={{ ...ui.th, textAlign: 'right' }}>{'지난달'}</th>}
                            <th style={ui.th}>{'수수료 방식'}</th>
                            <th style={{ ...ui.th, textAlign: 'right' }}>{'이번 달 수수료'}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sales.map((r) => {
                            const st = statOf(r.id);
                            return (
                                <tr key={r.id}>
                                    <td style={{ ...ui.td, fontWeight: 600 }}>{r.name}</td>
                                    <td style={ui.td}>
                                        <span style={styles.code}>{r.code}</span>
                                        <button type="button" style={styles.linkBtn} onClick={() => copyLink(r.code)} title="기공소 가입 링크 복사"><Copy size={12} />{'링크'}</button>
                                    </td>
                                    <td style={ui.tdNum}>{`${st.labs}곳`}</td>
                                    <td style={{ ...ui.tdNum, fontWeight: 700 }}>{`${st.month}건`}</td>
                                    {!mobile && <td style={{ ...ui.tdNum, color: '#64748b' }}>{`${st.last}건`}</td>}
                                    <td style={ui.td}>
                                        <div style={styles.methodCell}>
                                            <select
                                                style={{ ...ui.select, padding: '5px 8px' }}
                                                value={r.method}
                                                onChange={(e) => setSales((p) => p.map((x) => (x.id === r.id ? { ...x, method: e.target.value, fee: e.target.value === 'rate' ? 5 : e.target.value === 'fixed' ? 2000 : 0 } : x)))}
                                            >
                                                <option value="fixed">{'건당 정액'}</option>
                                                <option value="rate">{'매출 비율'}</option>
                                                <option value="tier">{'구간'}</option>
                                            </select>
                                            {r.method === 'tier' ? (
                                                <span style={ui.muted}>{'50건까지 2,000 · 초과 3,000'}</span>
                                            ) : (
                                                <>
                                                    <input
                                                        style={styles.feeInput}
                                                        value={(r.fee || 0).toLocaleString('ko-KR')}
                                                        onChange={(e) => { const v = parseInt(e.target.value.replace(/[^0-9]/g, ''), 10) || 0; setSales((p) => p.map((x) => (x.id === r.id ? { ...x, fee: v } : x))); }}
                                                        inputMode="numeric"
                                                    />
                                                    <span style={ui.muted}>{r.method === 'rate' ? '%' : '원/건'}</span>
                                                </>
                                            )}
                                        </div>
                                    </td>
                                    <td style={{ ...ui.tdNum, fontWeight: 700, color: '#4338ca' }}>{won(commissionOf(r, st.month))}</td>
                                </tr>
                            );
                        })}
                        <tr>
                            <td style={{ ...ui.td, color: '#3730a3', fontWeight: 600 }}>{'직접 유치'}</td>
                            <td style={{ ...ui.td, color: '#94a3b8' }}>{'—'}</td>
                            <td style={ui.tdNum}>{`${direct.length}곳`}</td>
                            <td style={{ ...ui.tdNum, fontWeight: 700 }}>{`${direct.reduce((s, l) => s + l.monthCount, 0)}건`}</td>
                            {!mobile && <td style={{ ...ui.tdNum, color: '#64748b' }}>{`${direct.reduce((s, l) => s + l.lastMonthCount, 0)}건`}</td>}
                            <td style={ui.td} />
                            <td style={ui.td} />
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}

function PartnerSettlement() {
    const mobile = useIsMobile();
    const [tab, setTab] = useState('sales');
    return (
        <div>
            <PageHeader icon={Wallet} title={'정산'} subtitle={'기공소 매출 명세서와 덴클 청구 내역을 봅니다.'} />
            <div style={mobile ? ui.bodyMobile : ui.body}>
                <SampleNotice />
                <div style={ui.tabs}>
                    {TABS.map((t) => (
                        <button key={t.key} type="button" style={{ ...ui.tab, ...(tab === t.key ? ui.tabActive : {}) }} onClick={() => setTab(t.key)}>
                            {t.label}
                        </button>
                    ))}
                </div>
                {tab === 'sales' && <PartnerStatement mobile={mobile} />}
                {tab === 'receivable' && <ReceivableTab mobile={mobile} />}
                {tab === 'dencl' && <DenclTab />}
                {tab === 'referral' && <ReferralTab mobile={mobile} />}
            </div>
        </div>
    );
}

const styles = {
    addRow: { display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' },
    feeSum: { fontSize: 13, color: '#334155' },
    code: { fontFamily: 'ui-monospace, Menlo, monospace', fontSize: 12, fontWeight: 700, color: '#075985' },
    linkBtn: {
        marginLeft: 6, display: 'inline-flex', alignItems: 'center', gap: 3, padding: '2px 7px', border: '1px solid #cbd5e1',
        borderRadius: 6, backgroundColor: '#fff', color: '#334155', fontSize: 11, fontWeight: 600, cursor: 'pointer',
    },
    methodCell: { display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' },
    tierRow: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 10 },
    tierCard: { ...ui.card, padding: 14, display: 'flex', flexDirection: 'column', gap: 4 },
    tierOn: { borderColor: '#6366f1', boxShadow: '0 0 0 1px #6366f1', backgroundColor: '#fafaff' },
    feeInput: { width: 70, padding: '5px 8px', border: '1px solid #cbd5e1', borderRadius: 7, fontSize: 13, textAlign: 'right' },
    smallBtnPrimary: {
        display: 'inline-flex', alignItems: 'center', gap: 3, padding: '4px 10px', border: '1px solid #c7d2fe',
        borderRadius: 7, backgroundColor: '#eef2ff', color: '#4338ca', fontSize: 12, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap',
    },
    col: { display: 'flex', flexDirection: 'column', gap: 10 },
    btnRow: { display: 'inline-flex', gap: 4 },
    smallBtn: {
        display: 'inline-flex', alignItems: 'center', gap: 3, padding: '4px 8px', border: '1px solid #cbd5e1',
        borderRadius: 7, backgroundColor: '#fff', color: '#334155', fontSize: 12, fontWeight: 600, cursor: 'pointer',
    },
};

export { ReferralTab, ReceivableTab, DenclTab };
export default PartnerSettlement;
